'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dismiss = require('../../dismiss');

var _dismiss2 = _interopRequireDefault(_dismiss);

require('../styles/Alert.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function Alert(_ref) {
  var className = _ref.className,
      renderIcon = _ref.renderIcon,
      handleDismiss = _ref.handleDismiss,
      children = _ref.children;

  var classNames = 'alert cp-alert ' + className;

  return _react2.default.createElement(
    'div',
    { className: classNames, role: 'alert', 'aria-live': 'polite', 'aria-atomic': 'true' },
    renderIcon && _react2.default.createElement(
      'span',
      { className: 'alert-icon' },
      renderIcon()
    ),
    _react2.default.createElement(
      'div',
      { className: 'alert-content' },
      children
    ),
    handleDismiss && _react2.default.createElement(_dismiss2.default, { handleDismiss: handleDismiss })
  );
};

Alert.propTypes = {
  className: _react.PropTypes.string,
  renderIcon: _react.PropTypes.func,
  handleDismiss: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

Alert.defaultProps = {
  className: ''
};

exports.default = Alert;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/alert/components/Alert.component.js
// module id = 1014
// module chunks = 1